import React from 'react'
import { colors } from '@/styles/colors'
import type { Confidence } from './fileTypeDetection'

/** Shared badge for auto-detected file types (V1 UnifiedUploadModal and the
 *  V2 AddDataModal) — one source so the confidence vocabulary can't drift.
 *  Not exported: react-refresh wants component files to export only components. */
const CONFIDENCE_STYLES: Record<Confidence, { textColor: string; bgColor: string; borderColor: string; label: string }> = {
  high:   { textColor: colors.success[700], bgColor: colors.success[50], borderColor: colors.success[200], label: 'Auto-detected' },
  medium: { textColor: colors.info[700],    bgColor: colors.info[50],    borderColor: colors.info[200],    label: 'Auto-detected' },
  low:    { textColor: colors.amber[700],   bgColor: colors.amber[50],   borderColor: colors.amber[200],   label: 'Please verify' },
}

export const ConfidenceBadge: React.FC<{ confidence: Confidence }> = ({ confidence }) => (
  <span
    className="inline-flex items-center whitespace-nowrap rounded-full px-2 py-0.5 text-[12px] font-medium"
    style={{
      color: CONFIDENCE_STYLES[confidence].textColor,
      backgroundColor: CONFIDENCE_STYLES[confidence].bgColor,
      border: `1px solid ${CONFIDENCE_STYLES[confidence].borderColor}`,
    }}
  >
    {CONFIDENCE_STYLES[confidence].label}
  </span>
)
